import { Moment } from 'moment';
import * as moment from 'moment';

enum RefreshEtaSource {
  GOOGLE = 'GOOGLE',
  CMA = 'CMA'
}

export enum RefreshDataStatus {
  TO_BE_UPDATED = 'TO_BE_UPDATED',
  ALREADY_UP_TO_DATE = 'ALREADY_UP_TO_DATE',
  ERROR = 'ERROR'
}

export class RefreshEtas {

  public driverEta: RefreshEta;
  public automaticEta: RefreshEta;

  static fromDto(e): RefreshEtas {
    const refreshEtas = new RefreshEtas();

    refreshEtas.automaticEta  = RefreshEta.fromDto(e.automatic_eta);
    refreshEtas.driverEta     = RefreshEta.fromDto(e.driver_eta);

    return refreshEtas;
  }
}

export class RefreshEta {

  public status: RefreshDataStatus
  public eta: Moment
  public etaUpdatedAt: Moment
  public source: RefreshEtaSource

  static fromDto(e): RefreshEta {
    const refreshEta = new RefreshEta();

    if (!e) {
      return null;
    }

    if (e) {
      refreshEta.eta           = e.eta ? moment(e.eta) : null;
      refreshEta.etaUpdatedAt  = e.eta_updated_at ? moment(e.eta_updated_at) : null;
      refreshEta.source        = e.source;
      refreshEta.status        = e.status;
    }

    return refreshEta;
  }
}
